import Axios from "axios";
import {
    SET_PRODUCTION_STYLE_LIST,
    UNSET_PRODUCTION_STYLE_LIST,
  } from "@/store/mutation-types";
import {
  styleResource,
} from "@/store/api";
const state = {
  getProductionStyleList: [],
};

const getters = {
  getProductionStyleList(state) {
    return state.getProductionStyleList;
  },
};

const mutations = {
  [SET_PRODUCTION_STYLE_LIST](state, data) {
    state.getProductionStyleList = data;
  },
  [UNSET_PRODUCTION_STYLE_LIST](state) {
    state.getProductionStyleList = [];
  },
};

const actions = {
    getProductionStyleList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(styleResource, { data })
                .then(function (response) {
                commit('SET_PRODUCTION_STYLE_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_PRODUCTION_STYLE_LIST')
                reject(error);
                })
                .then((always) => {
                });
        });
    },

    saveProductionStyle({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(styleResource, data)
            .then(function (response) {
            resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    updateProductionStyle({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
            const url = `${styleResource}/${id}`;

            Axios.put(url, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            })
            .finally(() => {
                commit("UNSET_LOADING");
            });
        });
    },

  
};

export default {
  state,
  getters,
  actions,
  mutations,
};
